export default __webpack_public_path__ + "static/media/MZ.4e2241e2.svg";